export default "__VITE_ASSET__CSuOhOwu__"